import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import DashboardPage from './pages/DashboardPage.js';
import DiagnosticsPage from './pages/DiagnosticsPage.js';
import DeviceHealthPage from './pages/DeviceHealthPage.js';
import LoginPage from './pages/auth/LoginPage.js';
import RegisterPage from './pages/auth/RegisterPage.js';
import PasswordResetPage from './pages/auth/PasswordResetPage.js';
import AccountPage from './pages/AccountPage.js';
import HomePage from './pages/HomePage.js';
import DocsPage from './pages/DocsPage.js';
import { PrivacyPage, TermsPage, SupportPage, DeleteAccountPage } from './pages/LegalPages.js';

// A simple auth guard wrapper
const ProtectedRoute = ({ children }: { children: React.ReactNode }): JSX.Element => {
  const token = localStorage.getItem('velinko_token');
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
};

function App(): JSX.Element {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/reset-password" element={<PasswordResetPage />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/device/:deviceId/diagnostics"
          element={
            <ProtectedRoute>
              <DiagnosticsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/device/health"
          element={
            <ProtectedRoute>
              <DeviceHealthPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/account"
          element={
            <ProtectedRoute>
              <AccountPage />
            </ProtectedRoute>
          }
        />
        <Route path="/" element={<HomePage />} />
        <Route path="/docs" element={<DocsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/support" element={<SupportPage />} />
        <Route path="/delete-account" element={<DeleteAccountPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
